import { db } from "./firebase";
import {
  collection, addDoc, getDocs, getDoc, updateDoc,
  doc, query, where, orderBy, serverTimestamp
} from "firebase/firestore";

const COL = "invoices";

// Admin cost per kg (internal, not shown to customer)
export const ADMIN_COST_PER_KG = 12;

export function generateInvoiceNumber() {
  const date = new Date();
  const yy   = date.getFullYear().toString().slice(2);
  const mm   = String(date.getMonth() + 1).padStart(2, "0");
  const rand = Math.random().toString(36).substring(2, 5).toUpperCase();
  return `LBM-INV-${yy}${mm}-${rand}`;
}

// Calculate totals for an invoice
export function calculateInvoiceTotals(shipment, packages, customerRatePerKg, requests = []) {
  // Total weight of all packages in shipment
  const totalWeightLbs = packages.reduce((sum, p) => sum + parseFloat(p.weight || 0), 0);
  const totalWeightKg  = totalWeightLbs * 0.453592;

  // Shipping cost (customer rate)
  const shippingCost   = totalWeightKg * (customerRatePerKg || 0);

  // Services/requests cost
  const servicesCost   = requests.reduce((sum, r) => sum + (r.totalCost || 0), 0);

  // Total customer pays
  const totalDue       = shippingCost + servicesCost;

  // Profit calculation (admin only)
  const adminCost      = totalWeightKg * ADMIN_COST_PER_KG;
  const profit         = shippingCost - adminCost;

  return {
    totalWeightLbs: totalWeightLbs.toFixed(2),
    totalWeightKg:  totalWeightKg.toFixed(2),
    shippingCost:   shippingCost.toFixed(2),
    servicesCost:   servicesCost.toFixed(2),
    totalDue:       totalDue.toFixed(2),
    adminCost:      adminCost.toFixed(2),
    profit:         profit.toFixed(2),
  };
}

export async function createInvoice(data) {
  return await addDoc(collection(db, COL), {
    invoiceNumber:    data.invoiceNumber,
    shipmentId:       data.shipmentId,
    shipmentTracking: data.shipmentTracking,
    customerEmail:    data.customerEmail.toLowerCase().trim(),
    customerName:     data.customerName,
    packageIds:       data.packageIds,
    ratePerKg:        data.ratePerKg,
    totalWeightLbs:   data.totalWeightLbs,
    totalWeightKg:    data.totalWeightKg,
    shippingCost:     data.shippingCost,
    servicesCost:     data.servicesCost,
    totalDue:         data.totalDue,
    adminCost:        data.adminCost,
    profit:           data.profit,
    status:           "Unpaid", // Unpaid | Paid
    paymentMethod:    "",
    paidAt:           null,
    whishNumber:      data.whishNumber || "",
    notes:            data.notes || "",
    createdAt:        serverTimestamp(),
    updatedAt:        serverTimestamp(),
  });
}

export async function getAllInvoices() {
  const q    = query(collection(db, COL), orderBy("createdAt", "desc"));
  const snap = await getDocs(q);
  return snap.docs.map(d => ({ id: d.id, ...d.data() }));
}

export async function getCustomerInvoices(email) {
  const q = query(
    collection(db, COL),
    where("customerEmail", "==", email.toLowerCase().trim()),
    orderBy("createdAt", "desc")
  );
  const snap = await getDocs(q);
  return snap.docs.map(d => ({ id: d.id, ...d.data() }));
}

export async function markInvoicePaid(id, method) {
  await updateDoc(doc(db, COL, id), {
    status:        "Paid",
    paymentMethod: method,
    paidAt:        serverTimestamp(),
    updatedAt:     serverTimestamp(),
  });
}
